import { render, staticRenderFns } from "./DetailBillByStudent.vue?vue&type=template&id=26d50234&scoped=true"
import script from "./DetailBillByStudent.vue?vue&type=script&lang=js"
export * from "./DetailBillByStudent.vue?vue&type=script&lang=js"
import style0 from "./DetailBillByStudent.vue?vue&type=style&index=0&id=26d50234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d50234",
  null
  
)

export default component.exports